const en_master_goodsPrice = {
    "": "change price",

    error: {
        update: 'Failed to update data',
    },

    success: {
        update: 'Data updated successfully',
    },
}

export default en_master_goodsPrice;